export const FIRST_NAME_MIN_LENGTH = 2;

export const FIRST_NAME_PROHIBITED_WORDS = ['unknown', 'na', 'nil', 'null'];

export const FIRST_NAME_RULES = {
    required: value => {
      return !!value || 'This field is required';
    },
    minLength(min) {
      return value => (!!value && value.trim().length >= min) || `Min ${min} characters`
    },
    onlyAllowedCharacters: value => {
      const regex = /^[A-Za-z\s'’\-àáâäãåąçćčèéêëęìíîïłńñńóôöõùúûüųūýÿžźż,&]*$/;
      return regex.test(value) || 'Numbers and special characters are not allowed';
    },
    denySpecificWords(forbiddenWords) {
      return value => (!!value && !forbiddenWords.includes(value.trim().toLowerCase())) || `This field cannot contain the word "${value}"`
    },
}